import React from 'react';
import clsx from 'clsx';
import { makeStyles, CircularProgress } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  container: {
    position: 'relative',
  },
  backdrop: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    zIndex: 1300,
    backgroundColor: 'rgba(255, 255, 255, 0.7)',
  },
  spinner: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    margin: 'auto',
  },
}));
interface OverlaySpinnerProps {
  isLoading?: boolean;
  children: React.ReactNode;
  className?: string;
}

const OverlaySpinner: React.FC<OverlaySpinnerProps> = ({
  isLoading,
  children,
  className,
}) => {
  const classes = useStyles();
  return (
    <div className={clsx(classes.container, className)}>
      {children}
      {isLoading && (
        <div className={classes.backdrop}>
          <CircularProgress className={classes.spinner} />
        </div>
      )}
    </div>
  );
};

export default OverlaySpinner;
